import { useCallback } from 'react';
import IncidentRosterData from 'components/IncidentConfig/IncidentRosterData';
import DailyPersonnelSignInSheet from './Resources/DailyPersonnelSignInSheet';
import { IapDraftRoster } from './IapDraftRoster';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useSearchParams } from 'react-router';

const IAPRoster: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const isDraft = searchParams.get('mode') === 'draft';

  const setMode = useCallback(
    (draft: boolean) => {
      setSearchParams(
        (searchParams) => {
          searchParams.set('mode', draft ? 'draft' : 'active');
          return searchParams;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  return (
    <div className="maincontent">
      <div className="p-2">
        <div className="iap-button-group d-flex align-items-center mb-3">
          <div className="iap-buttons">
            <StylishNewButton
              onClick={() => setMode(false)}
              className="button button--secondary button-one"
              style={
                !isDraft
                  ? {
                      backgroundColor: 'var(--success-600)',
                      color: 'var(--text-white)',
                    }
                  : {}
              }
            >
              Active Roster
            </StylishNewButton>
            <StylishNewButton
              onClick={() => setMode(true)}
              className="button button--secondary button-two"
              style={
                isDraft
                  ? {
                      backgroundColor: 'var(--brand-primary)',
                      color: 'var(--text-white)',
                    }
                  : {}
              }
            >
              Draft Roster
            </StylishNewButton>
          </div>
          <OverlayTrigger
            placement="right"
            overlay={(props) => (
              <Tooltip id="draft-roster-info-tooltip" {...props}>
                This draft roster will take effect on advance of the operational
                period
              </Tooltip>
            )}
          >
            <span
              className="d-inline-flex align-items-center ms-2 text-weak cursor-pointer"
              role="img"
              aria-label="This draft roster will take effect on advance of the operational period"
              style={{ visibility: isDraft ? 'visible' : 'hidden' }}
            >
              <SharedIcon iconName="info" size="sm" color="primary" />
            </span>
          </OverlayTrigger>
        </div>

        {!isDraft ? (
          <>
            <IncidentRosterData />
            <DailyPersonnelSignInSheet />
          </>
        ) : (
          <IapDraftRoster />
        )}
      </div>
    </div>
  );
};

export default IAPRoster;
